import { TaskModel } from 'models/task';

import { TaskManagerActions } from '../reducer';

export default function openEditTaskModal(dispatch) {
  return (task?: TaskModel) => {
    dispatch({ type: TaskManagerActions.OPEN_TASK_FORM, payload: task || null });
  };
}
